'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import registerEventListener from './helper/registerEventListener';

var NavigationDesktop = /*#__PURE__*/function () {
  function NavigationDesktop() {
    var _this = this;

    _classCallCheck(this, NavigationDesktop);

    _defineProperty(this, "handleMouseMove", function (e) {
      _this.hoverIntent.x = e.pageX;
      _this.hoverIntent.y = e.pageY;
    });

    _defineProperty(this, "resetActiveElement", function (targetEl) {
      var actives = _this.component.querySelectorAll(".".concat(_this.classes.active));

      Array.from(actives).forEach(function (el) {
        if (targetEl && el === targetEl.closest('li.level-top')) {
          return;
        }

        el.classList.remove(_this.classes.active);
        var maintitle = el.querySelector(".nav-desktop__maintitle");

        if (maintitle) {
          maintitle.setAttribute('aria-expanded', 'false');
        }

        var currentFlyout = el.querySelector('.nav-desktop__flyout');

        if (currentFlyout) {
          currentFlyout.style.transition = 'max-height 0.2s ease-out, visibility 0.2s ease-out, padding 0.2s ease-out';
          currentFlyout.style.maxHeight = '0';
          currentFlyout.style.visibility = 'hidden';
          currentFlyout.style.padding = '0';
        }
      });

      if (!targetEl) {
        _this.flyoutActive = false;
        _this.activeElement = null; // Reset active element tracking

        _this.hoverIntent.previous = null; // Reset previous element tracking
      }
    });

    _defineProperty(this, "showFlyout", function (element) {
      if (!element) return;
      var currentFlyout = element.querySelector('.nav-desktop__flyout');
      if (!currentFlyout) return; // Get the flyout's natural height

      currentFlyout.style.visibility = 'hidden';
      currentFlyout.style.maxHeight = 'none';
      var flyoutHeight = currentFlyout.scrollHeight; // Animate the flyout

      currentFlyout.style.maxHeight = '0';
      currentFlyout.style.visibility = 'visible'; // Trigger reflow

      currentFlyout.offsetHeight;
      currentFlyout.style.maxHeight = "".concat(flyoutHeight, "px");
      currentFlyout.style.padding = '32px';
      var maintitle = element.querySelector(".nav-desktop__maintitle");

      if (maintitle) {
        maintitle.setAttribute('aria-expanded', 'true');
      }

      element.classList.add(_this.classes.active);
      _this.flyoutActive = true;
      _this.activeElement = element; // Update active element tracking
    });

    _defineProperty(this, "interactWithMenu", function (e) {
      clearTimeout(_this.closeTimeout);
      var currentElement = e.target.closest('li.level-top'); // Always process the hover if we're hovering a new element or no element is currently active

      if (!_this.activeElement || currentElement !== _this.activeElement) {
        _this.resetActiveElement(e.target);

        _this.showFlyout(currentElement);
      }
    });

    _defineProperty(this, "controlFlyoutClose", function (e) {
      var relatedTarget = e.relatedTarget;
      var currentTarget = e.currentTarget; // Don't close if moving to a child element

      if (relatedTarget && currentTarget.contains(relatedTarget)) {
        return;
      } // Don't close if moving to another top-level item


      if (relatedTarget && relatedTarget.closest('li.level-top')) {
        return;
      }

      _this.closeTimeout = setTimeout(function () {
        if (!_this.flyoutActive) {
          _this.resetActiveElement();
        }
      }, _this.hoverIntent.timeout);
      _this.flyoutActive = false;
    });

    _defineProperty(this, "toggleFlyoutOnClick", function (e) {
      e.preventDefault();
      var clickedEl = e.target;
      var currentElement = clickedEl.closest('li.level-top');

      if (currentElement.classList.contains(_this.classes.active)) {
        _this.resetActiveElement();
      } else {
        _this.resetActiveElement(clickedEl);

        _this.showFlyout(currentElement);
      }
    });

    this.component = document.querySelector('.nav-desktop');
    this.topLevelItems = this.component.querySelectorAll('.level-top > a, .level-top > button');
    this.topLevelFlyoutItems = this.component.querySelectorAll('.level-top.has-tab');
    this.topLevelsText = this.component.querySelectorAll('.level-top.has-tab .nav-desktop__maintitle');
    this.classes = {
      active: 'is-active',
      hasTab: 'has-tab',
      interactiveElements: ['nav-desktop__maintitle', 'nav__button'],
      exclude: 'link--external'
    };
    this.flyoutActive = false;
    this.closeTimeout = null;
    this.hoverIntent = {
      sensitivity: 6,
      interval: 100,
      timeout: 200,
      x: 0,
      y: 0,
      previous: null
    };
    this.activeElement = null; // Track currently active element
  }

  _createClass(NavigationDesktop, [{
    key: "initEvents",
    value: function initEvents() {
      var _this2 = this;

      // Track mouse movement for hover intent
      document.addEventListener('mousemove', this.handleMouseMove);
      registerEventListener(this.topLevelsText, ['click'], this.toggleFlyoutOnClick);
      registerEventListener(this.topLevelItems, ['focus'], this.resetActiveElement);
      registerEventListener(this.topLevelsText, ['mouseenter'], this.interactWithMenu);
      registerEventListener(this.topLevelFlyoutItems, ['mouseleave'], this.controlFlyoutClose); // Improved flyout hover handling

      this.topLevelFlyoutItems.forEach(function (item) {
        var flyout = item.querySelector('.nav-desktop__flyout');

        if (flyout) {
          flyout.addEventListener('mouseenter', function () {
            clearTimeout(_this2.closeTimeout);
            _this2.flyoutActive = true;
          });
          flyout.addEventListener('mouseleave', function (e) {
            // Only process mouseleave if we're not moving to another menu item
            if (!e.relatedTarget || !e.relatedTarget.closest('.nav-desktop')) {
              _this2.controlFlyoutClose(e);
            }
          });
        }
      });
    }
  }]);

  return NavigationDesktop;
}();

export { NavigationDesktop as default };